import { render } from "./systemInformation.vue?vue&type=template&id=7afbaa12&scoped=true&ts=true"
import script from "./systemInformation.vue?vue&type=script&lang=ts"
export * from "./systemInformation.vue?vue&type=script&lang=ts"

import "./systemInformation.vue?vue&type=style&index=0&id=7afbaa12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7afbaa12"]])

export default __exports__